import {
    CartWorkflowStepValidationResults,
    DefaultCartWorkflowStepValidationResults
} from '../../CartWorkflow.types';
import { ICartProps } from '../../../../contexts/CartContext/CartContext.types';

const useValidatePickNumberPage = (cart: ICartProps): CartWorkflowStepValidationResults => {
    const results = DefaultCartWorkflowStepValidationResults();
    const lineItems = cart.lineItems;

    let missingNumber = false;
    let missingAgreement = false;
    lineItems.forEach((item) => {
        if (!item.phoneNumberInformation.needsNewNumber) {
            if (item.phoneNumberInformation.oldNumber === undefined) missingNumber = true;

            if (!item.phoneNumberInformation.acceptedPhoneNumberAgreement) missingAgreement = true;
        }
    });

    if (missingNumber) {
        results.messages.push(
            'For each line, you must provide a valid phone number to transfer or accept to receiving a new number.'
        );
        results.isValid = false;
    }

    if (missingAgreement) {
        results.messages.push(
            'For each line, you must accept the phone number agreement to continue.'
        );
        results.isValid = false;
    }

    return results;
};

export default useValidatePickNumberPage;
